/**
 * Where pack images live, portable across the two hosts that render these
 * components.
 *
 * The portal (Vite) serves the plate/scene JPEGs and `/lab/qr.svg` from its
 * own `public/pack/` — same origin, so a plain root-relative path
 * (`/pack/plates/plate-duo.jpg`) has always worked, and stays the default
 * (`base === ''`, i.e. every path resolves exactly as it did before this
 * package existed).
 *
 * template-monster's welcome-pack chunk runs on a different origin
 * (`<slug>.foundlio.com`) with no copy of those JPEGs — it points `packAsset`
 * at the portal instead (`setPackAssetBase('https://app.foundlio.com')`)
 * before the first render that needs one. Every asset path inside this
 * package should be routed through `packAsset()` rather than hardcoded, so
 * that call site is the only thing that has to know about the two hosts.
 */

let base = '';

/** Call once, before the first render that resolves a pack asset path. */
export function setPackAssetBase(next: string): void {
  base = next.replace(/\/+$/, '');
}

/** `path` must start with `/`. Resolves against whatever base was last set. */
export function packAsset(path: string): string {
  return `${base}${path}`;
}
